'use client';

import { Box, Divider, Flex, Group, ScrollArea, ThemeIcon, UnstyledButton } from '@mantine/core';
import { IconAdjustmentsHorizontal, IconLogout } from '@tabler/icons-react';
import { logoutAction } from '@/actions/logout';
import { ROLE } from '@/shared/const/roles';
import { useUserStore } from '@/shared/stores/userStore';
import { links as dashboardLinks } from '@/app/[lang]/dashboard/components/RightMenu.constants';
import AuthenticationForm from '@/app/components/shell/navbar/authentication/AuthenticationForm';
import { LinksGroup } from '@/app/components/shell/navbar/colapsed/LinksGroup';
import classes from '@/app/components/shell/navbar/colapsed/LinksGroup.module.css';
import { links, userLinks } from '@/app/components/shell/navbar/links';
import { useTranslation } from '@/i18n/client';

export function Collapsed() {
  const { t, lng } = useTranslation('links');
  const menu = links.map((item) => <LinksGroup {...item} key={item.label} />);
  const userMenu = userLinks.map((item) => <LinksGroup {...item} key={item.label} />);
  const { user, unsetUser } = useUserStore((state) => state);

  const logout = async () => {
    await logoutAction();
    unsetUser();
  };

  return (
    <ScrollArea h='calc(100vh - 80px' mx='-md'>
      <Divider my='sm' />

      {menu}

      <Divider my='sm' />
      {user ? (
        <>
          {userMenu}
          {user.role >= ROLE.SUPPORT && (
            <LinksGroup
              label='Dashboard'
              link={`/${lng}/dashboard`}
              icon={IconAdjustmentsHorizontal}
              links={dashboardLinks.filter((link) => link.role <= user.role)}
            />
          )}
          <Divider my='sm' />
          <UnstyledButton className={classes.control} onClick={logout}>
            <Group justify='space-between' gap={0}>
              <Flex align='center'>
                <ThemeIcon variant='light' size={30}>
                  <IconLogout size={18} color='rgba(204, 53, 53, 1)' />
                </ThemeIcon>
                <Box ml='md' c='rgba(204, 53, 53, 1)'>
                  {t('Logout')}
                </Box>
              </Flex>
            </Group>
          </UnstyledButton>
        </>
      ) : (
        <Group justify='center' grow pb='xl' px='md'>
          <AuthenticationForm />
        </Group>
      )}
    </ScrollArea>
  );
}
